import React, { Component } from 'react';
import { Alert, Button, Empty, Icon, Spin, Table } from 'antd';
import { contactsFromGroupColumns } from './columns/contactsFromGroupsColumns';
import { CONTACTS_RESOURCE_NAME, CONTACTS_GROUPS_RESOURCE_NAME } from '../../config/constants';
import { withCancellablePromise } from '../../hocs/withCancellablePromise';
import { _callResource } from '../../context/_callResource';
import TEXTS from '../../locale/texts';

class AddMsisdnsFromGroups extends Component {
  state = {
    tableData: [],
    message: '',
    isLoading: true,
    selectedRows: [],

    // contacts groups resource
    contactsGroupsData: [],
    contactsGroupsDataIsLoading: true,
    contactsGroupsDataError: null
  };

  callResource = _callResource.bind(this);
  columns = contactsFromGroupColumns.bind(this);

  componentDidMount = () => {
    const { promiseCancelToken } = this.props;
    this.setState({ selectedRows: [] });
    this.callResource({
      resourceName: CONTACTS_GROUPS_RESOURCE_NAME,
      apiClassName: 'contactsGroups',
      action: 'get',
      promiseCancelToken,
      onSuccess: (response) => {
        this.setState({
          tableData: response.data
            && response.data.items.length > 0
            && response.data.items.filter(({ contactCount }) => contactCount > 0)
        });
      }
    });
  };

  onCancel = () => {
    const { hideDrawer } = this.props;
    this.setState({
      msisdns: [],
      tableData: [],
      message: ''
    });
    hideDrawer();
  };

  addToCampaign = async () => {
    const { updateMsisdns, hideDrawer, promiseCancelToken } = this.props;
    const { selectedRows } = this.state;
    const groups = selectedRows.map(({ id }) => id);

    this.setState({ isLoadingAdd: true });

    const getAllContacts = ({ groupId }) => new Promise((resolve, reject) => {
      this.callResource({
        resourceName: CONTACTS_RESOURCE_NAME,
        apiClassName: 'contacts',
        action: 'get',
        apiCallParams: { groupId },
        promiseCancelToken,
        onSuccess: (response) => {
          resolve(response);
        },
        onError: (err) => {
          reject(err);
        }
      });
    });

    try {
      const contactsToAdd = await groups.reduce(async (acc, curr) => {
        const contactsToAdd = await getAllContacts({ groupId: curr });
        return [...(await acc), ...contactsToAdd.data.items];
      }, []);
      updateMsisdns(contactsToAdd, 'withParamsDisabled');
      this.setState({
        tableData: [],
        isLoadingAdd: false
      });
      hideDrawer();
    } catch (err) {
      console.log('addToCampaign (contacts from groups) error:::', err);
      this.setState({ isLoadingAdd: false });
    }
  };

  rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      this.setState({ selectedRows });
    }
  };

  renderData = () => {
    const { tableData, contactsGroupsDataError } = this.state;
    const columns = this.columns(this.props.lang);

    if (contactsGroupsDataError) {
      const { errorTitle, errorMessage } = contactsGroupsDataError;
      return (
        <Alert
          message={errorTitle}
          description={errorMessage}
          type="error"
        />
      );
    }

    return (
      <Table
        dataSource={tableData}
        columns={columns}
        rowKey={({ id }) => id}
        rowSelection={this.rowSelection}
      />
    );
  };

  render() {
    const { contactsGroupsDataIsLoading, isLoadingAdd, tableData, selectedRows } = this.state;
    const { lang } = this.props;

    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="t-light">{TEXTS.titleAddReceiversFromGroups[lang]}</h3>
          <div>
            {tableData &&
              <Button
                type="primary"
                size="large"
                style={{padding: '0 20px', height: 40, marginRight: 15, fontSize: 14}}
                onClick={this.addToCampaign}
                disabled={selectedRows.length === 0 || isLoadingAdd}
                loading={isLoadingAdd}
              >
                {TEXTS.btnAddMsisdn[lang]}
              </Button>}
            <Button
              style={{padding: '0 20px', height: 40, marginRight: 15, fontSize: 14}}
              onClick={this.onCancel}>
              {TEXTS.btnCancel[lang]}
            </Button>
          </div>
        </div>

        {contactsGroupsDataIsLoading
          ? <Empty description={TEXTS.dataIsLoading[lang]}>
            <div style={{marginTop: 15, textAlign: 'center'}}>
              <Spin spinning={true} />
            </div>
          </Empty>
          : this.renderData()}
      </div>
    );
  }
}

export default withCancellablePromise(AddMsisdnsFromGroups, 'getAllContactsGroups');
